import React from "react";
import Image from "next/image";
import Link from "next/link";

const Page410:React.FC = () => {
  return (
    <div className="page-404-middle py-12 lg:py-20">
      <section className="page-404-inner">
        <div className="max-w-7xl mx-auto px-4 lg:px-10">
          <div className="page-404-content bg-white rounded-lg shadow-lg p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Left Side */}
              <div>
                <div className="error-page-title">
                  <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
                    <span className="text-primary-500">Oops...!</span> Page{" "}
                    <u className="text-primary-500">Gone Forever</u>
                  </h1>
                </div>
                <div className="error-page-content mt-6 text-lg leading-relaxed text-gray-700">
                  <p>
                    Looks like this page has bid its final farewell. Unlike a
                    lost page that might turn up again, this one has been
                    permanently removed. But don’t worry—your journey doesn’t
                    have to end here. Let’s find a new path together! Head back
                    to our homepage or explore other sections—you might just
                    discover something even better.
                  </p>
                  <Link
                    href="/"
                    className="inline-block mt-8 px-6 py-3 bg-primary-500 text-white rounded-lg shadow hover:bg-primary-600 transition-colors duration-300"
                  >
                    Back to Home
                  </Link>
                </div>
              </div>

              {/* Right Side */}
              <div className="flex justify-center">
                <Image
                  width={500}
                  height={500}
                  src="/images/410.svg"
                  alt="410"
                  className="w-2/3 lg:w-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Page410;
